import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CHECKOUT_URL } from "../config";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`font-mono text-[10px] sm:text-[11px] tracking-[0.32em] uppercase text-lime ${className}`}
  >
    {children}
  </p>
);

export const CTAButton = ({ children, testId, className = "" }) => (
  <motion.a
    href={CHECKOUT_URL}
    data-testid={testId}
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.97 }}
    transition={{ duration: 0.25, ease: EASE }}
    className={`group inline-flex items-center justify-center gap-2 bg-lime text-ink font-display font-bold uppercase tracking-wide text-sm sm:text-base px-7 py-4 transition-colors duration-300 hover:bg-cream ${className}`}
  >
    {children}
    <ArrowUpRight
      size={18}
      strokeWidth={2.5}
      className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
    />
  </motion.a>
);

export const Rule = ({ className = "" }) => (
  <div className={`h-px bg-cream/10 ${className}`} aria-hidden="true" />
);
